type PrimaryCTAProps = {
  href?: string;
  onClick?: () => void;
  children?: React.ReactNode;
  className?: string;
  type?: "button" | "submit" | "reset";
};

export function PrimaryCTA({
  href = "https://calendly.com/nathan-alspaugh/new-meeting",
  onClick,
  children = "Book a call",
  className,
  type = "button",
}: PrimaryCTAProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    if (href) {
      if (/^https?:\/\//.test(href)) {
        window.open(href, "_blank", "noopener,noreferrer");
      } else {
        window.location.href = href;
      }
    }
  };

  return (
    <button
      type={type}
      onClick={handleClick}
      className={`hero-btn hero-btn--iri${className ? ` ${className}` : ""}`}
    >
      {children}
    </button>
  );
}
